import { Nullable } from 'chaika-common-types';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export function calculateGestationalAge(
    isPregnant: boolean,
    date: string,
    entryCreationTime: Date = new Date(),
    weeks: number = 0,
    days: number = 0,
): Nullable<number> {
    let result = null;

    if (isPregnant && date) {
        let currentTime = new Date().getTime();
        try {
            currentTime = entryCreationTime.getTime();
        } catch (e) {
            console.error(e);
        }
        const dateTime = new Date(date).getTime();
        result = Math.floor((currentTime - dateTime + weeks * WEEK + days * DAY) / WEEK);
    }

    return result;
}

export function calculateEstimatedDeliveryDate(
    isPregnant: boolean,
    date: string,
    weeks: number = 0,
    days: number = 0,
): Nullable<string> {
    let result = null;

    if (isPregnant && date) {
        const dateTime = new Date(date).getTime();
        const estimatedDeliveryTime = dateTime + 280 * DAY - weeks * WEEK - days * DAY;
        result = new Date(estimatedDeliveryTime).toISOString().substr(0, 10);
    }

    return result;
}

export function calculateDayOfMenstrualCycle(date: string, entryCreationTime: Date = new Date()): Nullable<number> {
    let result = null;

    if (date) {
        const dateTime = new Date(date).getTime();
        const nowTime = entryCreationTime.getTime();

        result = Math.ceil((nowTime - dateTime) / DAY);
    }

    return result === 0 ? null : result;
}

export function calculateOvaryVolume(length: number, width: number, thickness: number): Nullable<number> {
    let result = null;

    if (length && width && thickness) {
        const resultInMillimetres = length * width * thickness * 0.523;
        result = resultInMillimetres * 0.001;
    }

    return result;
}

export function BODY_MASS_INDEX(weight: number, height: number): Nullable<number> {
    return height ? (10000 * weight) / (height * height) : null;
}

export function BSA(weight: number = 0, height: number = 0): string {
    return (0.007184 * height ** 0.725 * weight ** 0.425).toFixed(2);
}

export const calculateUterusVolume = (longitudinalSize: number, transverseSize: number, thickness: number): number =>
    longitudinalSize * transverseSize * thickness * 0.523;
